import cx from 'classnames';

import { fonts } from '@/constants/fonts';

import styles from './Tag.module.scss';

export const Tag: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className={cx(styles.tag, fonts.barlow.className)}>
      <span className={styles.circle} />
      {children}
    </div>
  );
};
